import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { apm } from "./Apm";
import { _TEST1234 } from "./ApiConfig";

const ApmConfig = () => {
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const menuId = searchParams.get("menuId");

    const getCustomContext = () => {
        let customContext = { signed: "false", user: "none", token: "none" };
        const userInfo = sessionStorage.getItem("user-info");
        if (userInfo) {
            const parsedUserInfo = JSON.parse(userInfo);
            customContext.signed = "true";
            customContext.user = parsedUserInfo?.usrId ?? "unknown";
            customContext.token = _TEST1234.AUTHORIZATION ?? "unknown";
        }
        return customContext;
    };

    const getRoutePath = (pathname: any, menuId: any) => {
        const menuIdQuery = menuId ? `?menuId=${menuId}` : "";
        const routePath = pathname + menuIdQuery;
        return routePath;
    };

    useEffect(() => {
        if (apm) {
            const customContext = getCustomContext();
            const routePath = getRoutePath(pathname, menuId);

            apm?.setCustomContext?.(customContext);
            const transaction = apm?.startTransaction?.(routePath, "route-change", { managed: true });
            const blocker = transaction?.startSpan?.("route-change-blocker", "app", { blocking: true });

            return () => {
                blocker?.end?.();
                transaction?.end?.();
            };
        }
    }, [pathname, menuId]);

    return null;
};

export default ApmConfig;
